import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FirebaseFeatureFlags } from '@shared/enums/firebase-custom-claims.enum';
import { FeatureFlagService } from '@shared/services/feature-flag.service';
import { filter, map, Observable, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProPageGuard implements CanActivate {
  constructor(
    private _featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._featureFlagService.getFlagsLoaded().pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this._featureFlagService.getFeatureFlags().pipe(take(1))),
      map(({ flags }) => {
        const hasProMenu = flags.includes(FirebaseFeatureFlags.PRO_MENU);
        const hasPro = flags.includes(FirebaseFeatureFlags.PRO);

        if (hasPro || hasProMenu) {
          return true;
        }

        return this.router.createUrlTree(['/']);
      })
    );
  }
}
